/**
 * Ryan O'Dowd
 * 2024-11-11
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    container: {
      fontSize: globalScale * 15,
      color: colors.dialogText,
      fontFamily: fonts.primaryItalic,// @TODO: this isn't working on ios
      marginVertical: globalScale * 4,
    },
    titleText: {
      fontSize: globalScale * 17,
      fontFamily: fonts.primaryBold,
      color: colors.dialogText,
    },
  };
};

export default getStyles;
